import React from 'react'
import SaveIcon from 'client/utils/icons/save-icon'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcInput,
  DcText,
  PixelFactoryContext,
  PixelFlexBox,
} from 'pixel-base'

import { addUser } from 'utils/api-routes.util'
import { IPixelFactory, IUser } from '../../../../../../decl.d'

const AddNewPartyForm = (props: {
  handleClose: (data: IUser) => void
  userRole: { description: string; id: string }[]
}) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const { userRole, handleClose } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    name: '',

    role_id: '',
    email: '',
    password: '',
    confirm_password: '',
  })

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleAddNewUser()
  }

  const handleAddNewUser = () => {
    showPageLoader()
    addUser(data).subscribe((res) => {
      const response = res.response as {
        data: IUser | { error: string; field: string }
      }
      hidePageLoader()
      if (response.data) {
        showSuccess('Successfully Added')
        handleClose(response.data)
      } else {
        if (response.error && response.field && response.error !== '') {
          setError({
            error: response.error,
            field: response.field,
          })
        } else {
          showFailure(response.error)
        }
      }
    })
  }
  return (
    <>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
        onSubmit={handleSubmit}
      >
        <PixelFlexBox
          flexDirection="row"
          justifyContent="center"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Full Name
            </DcText>
            <DcInput
              tabIndex={1}
              error={
                error.field === 'name' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'text'}
              name={'name'}
              placeholder={'Full Name'}
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          justifyContent="center"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              User Role
            </DcText>
            <DcDropDown
              tabIndex={2}
              error={
                error.field === 'role_id' && error.error !== ''
                  ? error.error
                  : null
              }
              options={[
                ...userRole,
                { description: 'Select Role', id: '' },
              ].map((data) => {
                return { label: data.description, value: data.id }
              })}
              placeholder={'User Role'}
              name={'city'}
              value={data.role_id}
              onChange={(e) => setData({ ...data, role_id: e.target.value })}
            />
          </DcDiv>

          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Email
            </DcText>
            <DcInput
              tabIndex={3}
              error={
                error.field === 'email' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              type={'email'}
              name={'email'}
              placeholder={'Email'}
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          justifyContent="center"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              password
            </DcText>
            <DcInput
              tabIndex={4}
              className="full-width"
              error={
                error.field === 'password' && error.error !== ''
                  ? error.error
                  : null
              }
              required
              name={'password'}
              type={'password'}
              placeholder={'Enter your password'}
              value={data.password}
              onChange={(e) => setData({ ...data, password: e.target.value })}
            />
          </DcDiv>
          <DcDiv
            width="100%"
            height="auto"
            style={{
              display: 'flex',

              flexDirection: 'column',
              alignItems: 'flexStart',
            }}
          >
            <DcText
              style={{
                textAlign: 'left',

                color: '#2e314a',
                fontSize: '.875rem',
                fontWeight: '500',
                marginBottom: '.5rem',
              }}
            >
              Confirm password
            </DcText>
            <DcInput
              tabIndex={5}
              error={
                (error.field === 'confirm_password' && error.error !== ''
                  ? error.error
                  : null) ||
                (data.confirm_password &&
                data.confirm_password !== data.password
                  ? 'password does not match.'
                  : null)
              }
              required
              type={'password'}
              name={'confirm_password'}
              placeholder={'Confirm your password'}
              value={data.confirm_password}
              onChange={(e) =>
                setData({ ...data, confirm_password: e.target.value })
              }
            />
          </DcDiv>
        </PixelFlexBox>
        <PixelFlexBox
          flexDirection="row"
          justifyContent="flex-end"
          gap="10px"
          width="100%"
          style={{ flexGrow: 1 }}
        >
          <DcButton
            variant="primary"
            type="submit"
            tabIndex={6}
            withIcon={true}
            size="sm"
          >
            <SaveIcon size={16} />
            <span>Save</span>
          </DcButton>
        </PixelFlexBox>
      </form>
    </>
  )
}

export default AddNewPartyForm
